import React from 'react';
import { __, sprintf } from '@wordpress/i18n';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useNavigate } from 'react-router-dom';

// tools
import formatDeadlineDate from '../../helpers/formatDeadlineDate';
import getNumberWithCurrency from '../../helpers/getNumberWithCurrency';

// store
import { useStoreValue } from '../../store';

// components
import ButtonFlat from '../../components/ButtonWrapper/components/ButtonFlat';
import WidgetProjects from '../Dashboard/components/WidgetProjects';
import StatusIconComponent from '../../components/StatusIconComponent';
import CommCenterProjects from './components/CommCenterProjects';

const Projects = () => {
    const navigate = useNavigate();
    const projects = useStoreValue('projects');

    const goToProject = (id) => {
        navigate(`/projects/${id}`)
    }

    return (
        <>
            <div className="appDashboard">
                <div className="appDashboard__workbench workbenchProjects">
                    <OverlayScrollbarsComponent element="div" style={{ width: '100%', flex: 1, minHeight: 0 }} options={{ scrollbars: { autoHide: 'never' } }} defer>
                    <ul className="projectCards">
                        {projects.map(o => (
                            <li
                                className="projectCard"
                                key={o.id}
                                tabIndex={0}
                                role="button"
                                onClick={() => goToProject(o.id)}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToProject(o.id); } }}
                            >
                                <picture className="projectCard__thumbnail">
                                    <img
                                        src={o.thumbnailUrl}
                                        alt={o.title}
                                        loading="lazy"
                                    />
                                </picture>
                                <div className="projectCard__meta">
                                    <div className="projectCard__title">
                                        <StatusIconComponent status="in_progress" />
                                        {o.title}
                                    </div>
                                    <div className="projectCard__deadline">
                                        {sprintf(__('Scadenza: %s'), formatDeadlineDate(o.deadline))}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                    </OverlayScrollbarsComponent>
                </div>
                <CommCenterProjects/>
            </div>
            <div className="appDashboard__widgets">
                <WidgetProjects/>
                <div className="appDashboard__widget">
                    <div className="appDashboard__widgetTitle">
                        <h2>{__('Guadagni totali', 'soundbetween')}</h2>
                        <span>{getNumberWithCurrency(0)}</span>
                    </div>
                    <p>{__('Qui potrai tenere sotto controllo l’andamento dei tuoi lavori su Soundbetween', 'soundbetween')}</p>
                </div>
                <div className="appDashboard__widget">
                    <div className="appDashboard__widgetTitle">
                        <h2>{__('Contatti', 'soundbetween')}</h2>
                        <div>
                            <span>0</span>
                            <ButtonFlat
                                disabled={true}
                                onClick={() => {
                                }}>
                                {__('Aggiungi contatto', 'soundbetween')}
                            </ButtonFlat>
                        </div>
                    </div>
                    <p>{__('Crea il tuo primo progetto per aggiungere persone al tuo network e creare Team', 'soundbetween')}</p>
                </div>
            </div>
        </>
    )
}

export default Projects;